const api = function () {
};

api.host = () => {
    return 'http://localhost:9090/'
};


api.post = (vue, url, params) => {
    if (!params) {
        params = new FormData();
    }
    {
        let admin = JSON.parse(sessionStorage.getItem('_admin_'));
        if (admin) {
            params.append("admin_id", admin.id);
        }
    }
    return vue.$axios.post(url, params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(res => res.data);
};

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js